<template>
  <div :class="$style[classes]">
    <pt-page-title :title="'“'+name+'”报名记录'" :isSearch="true" @search="search" :searchKey="searchKey"  @emptySearch="emptySearch"></pt-page-title>
        <pt-page-factor-filter v-if="filterLabels()&&filterLabels().length" :labels="filterLabels()" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="primary" @click="exportNotes" :loading="exportLoading">导出</el-button>
            <el-button type="primary" @click="exportHistoryNotes">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
            <!-- <el-button type="primary" v-if="hasTaskAllocation" @click="batchAllocation">批量分配任务</el-button> -->
          </template>
      </pt-page-factor-filter>
    <pt-notes-table ref="table" :isTwentiethSurvey="isTwentiethSurvey" :isTwentyAnniversary="isTwentyAnniversary" :id="id" :params-data="paramsData" :isFromRouter="isFromRouter" :isParse="isParse" :isQuestion="isQuestion" :isReportQuestion="isReportQuestion"
     :isLifeExperienceHall="isLifeExperienceHall">
      <template>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-button type="text" v-if="hasRemark(scope.row)" @click="getRemark(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <template v-if="isReportInterpret">
          <el-table-column label="预约时间">
            <template slot-scope="scope">
              {{scope.row.parse_date}}
            </template>
          </el-table-column>
        <el-table-column label="预约状态" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" v-if="showStatus(scope.row)" @click="changeStatus(scope.row)">{{scope.row.sign_status}}</el-button>
            <span v-else>{{scope.row.sign_status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="复购意向"  fixed="right">
          <template slot-scope="scope">
            <el-button type="text" v-if="showReadDetailButton(scope.row)" @click="purchaseIntention(scope.row)">{{scope.row.repurchase_intention?scope.row.repurchase_intention:'复购意向'}}</el-button>
            <span v-else>{{scope.row.repurchase_intention?scope.row.repurchase_intention:'--'}}</span>
          </template>
        </el-table-column>
        </template>
        <el-table-column label="任务分配" v-if="hasTaskAllocation" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" v-if="showInvalid(scope.row)" @click="allocatePersonnel(scope.row)">分配人员</el-button>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="100">
          <template  slot-scope="scope">
            <el-button type="text"  v-if="showEditButton(scope.row)" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" v-if="showConfirmButton(scope.row)"  @click="confirm(scope.row)">确认</el-button>
            <el-button type="text" v-if="showReadDetailButton(scope.row)" @click="reportReadDetail(scope.row)">解读详情</el-button>
            <!-- <el-button type="text" v-if="showReadButton(scope.row)" @click="reportRead(scope.row)">解读完成</el-button> -->
            <el-button type="text" @click="getDetail(scope.row)">详情</el-button>
            <el-button type="text" v-if="showInvalid(scope.row)" @click="invalid(scope.row)">过期失效</el-button>
          </template>
        </el-table-column>
      </template>
    </pt-notes-table>
    <el-dialog title="解读详情" v-if="reportReadDialog" :visible.sync="reportReadDialog">
      <pt-notes-dialog :hasRead="hasRead" @onCancel="onCancel" :id="reportReadId"></pt-notes-dialog>
    </el-dialog>
    <el-dialog title="预约状态变更" v-if="statusDialog" :visible.sync="statusDialog">
      <status-dialog :rowData="rowData" @changeStatusCancel="changeStatusCancel"></status-dialog>
    </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import ptNotesTable from './pt-notes-table/withData'
import { filterLabelsActive } from './active-sign-notes'
import { reportReadStatus, workflowHallStatus } from 'json/sign'
import { filterLabels } from '../utils-filed'
import { emptyObject } from '@/utils/lifebankUtils'
import { existenceOfArrOrObj } from '@/utils/formUtils'
import { filterLabelsFunction } from '../sign-utils'
import ptNotesDialog from './pt-notes-dialog/withData'
import statusDialog from './status-dialog'
import { hasPermissions } from 'utils/permissions'
const PERM_REGISTRATION_REPORT_DISTRIBUTE = 'PERM_REGISTRATION_REPORT_DISTRIBUTE'
const prefixCls = 'pt-active-sign-notes'
export default {
  name: 'pt-active-sign-notes',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    },
    getTableData () {
      return this.$refs.table.getTableData()
    },
    isParse () {
      return this.$route.name === 'parse-sign-notes'
    },
    isQuestion () {
      return this.$route.name === 'question-notes'
    },
    isLifeExperienceHall () {
      return this.signDetail.ruleActivityCode === 'LIFE_EXPERIENCE_HALL'
    },
    isTwentyAnniversary () {
      return this.signDetail.ruleActivityCode === 'TWENTIETH_ANNIVERSARY_ACT'
    },
    // 是否是20周年调查问卷
    isTwentiethSurvey () {
      return this.signDetail.ruleActivityCode === 'TWENTIETH_SURVEY'
    },
    // 是否是报告预约解读满意度调查问卷
    isReportQuestion () {
      return this.signDetail.ruleActivityCode === 'SATISFACTION_SURVEY'
    },
    hasTaskAllocation () {
      return this.signDetail.ruleActivityCode === 'REPORT_INTERPRET' && this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_REGISTRATION_REPORT_DISTRIBUTE)
    },
    // 判断列表是否是报告预约解读（如果是报告预约解读，将设置操作栏宽度）
    isReportInterpret () {
      return this.signDetail.ruleActivityCode === 'REPORT_INTERPRET'
    }
  },
  components: {
    ptNotesTable,
    ptNotesDialog,
    statusDialog
  },
  props: {
    name: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    signDetail: {
      type: Object
    },
    hospitalList: {
      type: Array
    },
    provinceList: {
      type: Array
    },
    areaList: {
      type: Array
    },
    readPersonnelList: {
      type: Array
    },
    exportLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      searchKey: null,
      params: {},
      paramsData: {},
      isFromRouter: false,
      hasRegistionStatus: false,
      filterLabel: filterLabelsActive,
      reportReadDialog: false,
      reportReadId: '',
      hasRead: true,
      rowData: {},
      statusDialog: false
    }
  },
  watch: {
    signDetail: {
      handler: function (val) {
        this.filterLabel = filterLabelsFunction(val)
      },
      immediate: true
    },
    params: {
      handler: function (val, old) {
        if (val.hasOwnProperty('userRegistrationStatus') && this.paramsData.hasOwnProperty('workflowStatus') && !this.paramsData.hasOwnProperty('userRegistrationStatus')) {
          this.$delete(this.params, 'workflowStatus')
          this.hasRegistionStatus = true
        }
      }
    },
    areaList: {
      handler: function (val) {
        let temp = []
        val.forEach(item => {
          temp.push({ label: item, value: item })
        })
        this.filterLabel.forEach(item => {
          if (item.value === 'area') {
            item.options = temp
          }
        })
      },
      deep: true,
      immediate: true
    },
    readPersonnelList: {
      handler: function (val) {
        let temp = []
        val.forEach(item => {
          temp.push({ label: item.name, value: item.userId })
        })
        this.filterLabel.forEach((item, index) => {
          if (item.value === 'allotUserId') {
            if (!this.hasTaskAllocation) {
              this.filterLabel.splice(index, 1)
            }
            item.options = temp
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    invalid (row) {
      this.$emit('invalid', row)
    },
    onCancel () {
      this.reportReadDialog = false
      this.$refs.table.getTableData()
    },
    showInvalid (row) {
      return row.activityCode === 'REPORT_INTERPRET' && row.status === 'SUCCESS' && (row.workflowStatus === 'UNCONFIRMED' || row.workflowStatus === 'CONFIRMED')
    },
    showReadButton (row) {
      return row.activityCode === 'REPORT_INTERPRET' && row.status === 'SUCCESS' && row.workflowStatus === 'CONFIRMED'
    },
    showReadDetailButton (row) {
      return row.activityCode === 'REPORT_INTERPRET' && row.status === 'SUCCESS' && (row.workflowStatus === 'CONFIRMED' || row.workflowStatus === 'INTERPRETED')
    },
    showStatus (row) {
      return row.activityCode === 'REPORT_INTERPRET' && row.status === 'SUCCESS' && (row.workflowStatus === 'UNCONFIRMED' || row.workflowStatus === 'CONFIRMED')
    },
    // 改变状态
    changeStatus (row) {
      this.statusDialog = true
      this.rowData = row
    },
    changeStatusCancel () {
      this.statusDialog = false
      this.$refs.table.getTableData()
    },
    reportRead (row) {
      this.$emit('reportRead', row)
    },
    reportReadDetail (row) {
      this.reportReadId = row.id
      this.reportReadDialog = true
      this.hasRead = true
    },
    purchaseIntention (row) {
      this.reportReadId = row.id
      this.reportReadDialog = true
      this.hasRead = false
    },
    allocatePersonnel (val) {
      this.$router.push(`/assigned-tasks-form/${this.id}/${val.id}`)
    },
    batchAllocation () {
      this.$router.push(`/assigned-tasks-form/${this.id}/0`)
    },
    showEditButton (row) {
      return (row.activityCode === 'LIFE_EXPERIENCE_HALL' || row.activityCode === 'TWENTIETH_ANNIVERSARY_ACT') && row.status === 'SUCCESS' && row.workflowStatus !== 'SIGNED_IN'
    },
    edit (row) {
      this.$router.push('/sign-notes-form/' + true + '/' + this.id + '/' + row.id)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    showConfirmButton (row) {
      return (row.activityCode === 'LIFE_EXPERIENCE_HALL' || row.activityCode === 'TWENTIETH_ANNIVERSARY_ACT') && row.status === 'SUCCESS' && row.workflowStatus === 'UNCONFIRMED'
    },
    confirm (row) {
      this.$emit('confirm', row)
    },
    exportNotes () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          this.FilterData()
          // let data = JSON.parse(JSON.stringify(this.params))
          // let paramsData = {}
          // this.filterLabel.forEach(item => {
          //   paramsData[item.value] = this.params[item.value]
          //   if (item.type === 'time-slot') {
          //     paramsData = { ...paramsData, ...data[item.value] }
          //     if (paramsData[item.value]) {
          //       this.$delete(paramsData, item.value)
          //       this.$delete(paramsData, 'index')
          //     }
          //   }
          // })
          // this.filterLabels().forEach(item => {
          //   if (data[item.value] && data[item.value].index) {
          //     this.$delete(data[item.value], 'index')
          //   }
          // })
          let paramsData = this.FilterData()
          paramsData = { ...paramsData,
            searchKey: this.searchKey,
            mallRegistrationId: this.id }
          this.$emit('exportSign', paramsData)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },

    exportHistoryNotes () {
      let url = this.isQuestion ? '/export-history/sign-of-question?name=mall_registration'
        : (this.isParse ? '/export-history/sign-of-parse?name=mall_registration' : '/export-history/sign-of-active?name=mall_registration')
      this.$router.push(url)
    },
    filterLabels () {
      let data = (this.signDetail && this.signDetail.form && this.signDetail.form.fields) || []
      let label = [...filterLabels(data, this.hospitalList, this.provinceList), ...this.filterLabel] || []
      return label
    },
    FilterData (isFromRouter) {
      let data = JSON.parse(JSON.stringify(this.params))
      let paramsData = {}
      this.filterLabel.forEach(item => {
        paramsData[item.value] = data[item.value]
        this.$delete(data, 'item.value')
        if (item.type === 'time-slot') {
          if (data[item.value] && data[item.value].index) {
            this.$delete(data[item.value], 'index')
          }
          paramsData = { ...paramsData, ...data[item.value] }
          if (data[item.value]) {
            this.$delete(data, item.value)
          }
          if (paramsData[item.value]) {
            this.$delete(paramsData, item.value)
          }
        }
      })
      paramsData = { ...paramsData, ...data }
      let params = {}
      for (let key in paramsData) {
        if (!paramsData[key]) {
          this.$delete(paramsData, key)
        }
        if (key === 'userRegistrationStatus') {
          if (this.signDetail.ruleActivityCode === 'REPORT_INTERPRET' && existenceOfArrOrObj(reportReadStatus, paramsData[key])) {
            this.$set(paramsData, 'workflowStatus', paramsData[key])
            this.$delete(paramsData, 'userRegistrationStatus')
          }
          if ((this.signDetail.ruleActivityCode === 'LIFE_EXPERIENCE_HALL' || this.signDetail.ruleActivityCode === 'TWENTIETH_ANNIVERSARY_ACT') && existenceOfArrOrObj(workflowHallStatus, paramsData[key])) {
            this.$set(paramsData, 'workflowStatus', paramsData[key])
            this.$delete(paramsData, 'userRegistrationStatus')
          }
        }
        this.filterLabels().forEach(item => {
          if (item.needFilter && item.value === key) {
            params[key] = paramsData[key]
            paramsData = { ...paramsData, params: params }
            this.$delete(paramsData, key)
          }
        })
      }
      return paramsData
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      if (this.hasRegistionStatus) { this.$delete(this.paramsData, 'workflowStatus') }
      this.paramsData = this.FilterData(isFromRouter)
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
    },
    cleanParams () {
      emptyObject(this.paramsData)
      emptyObject(this.params)
      this.Filter()
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch () {
      this.searchKey = null
      if (this.paramsData.searchKey) {
        this.$delete(this.paramsData, 'searchKey')
      }
    },
    getRemark (row) {
      let remark = row.genericFormData && row.genericFormData.data && row.genericFormData.data.remark
      this.$alert(remark, '查看备注', {
        confirmButtonText: '确定',
        callback: action => {
        }
      })
    },
    // 该条记录是否有备注
    hasRemark (row) {
      let remark = false
      if (row.genericFormData && row.genericFormData.data && row.genericFormData.data.remark) {
        remark = true
      }
      return remark
    },
    getDetail (row) {
      let link
      switch (row.eventType) {
        case 'QUESTIONNAIRE':
          link = '/question-sign/notes-detail/' + row.id + '/' + this.id
          break
        case 'PARSE':
          link = '/parse-sign/notes-detail/' + row.id + '/' + this.id
          break
        default:
          link = '/active-sign/notes-detail/' + row.id + '/' + this.id
          break
      }
      // let link = this.isParse ? '/parse-sign/notes-detail/' + row.id + '/' + this.id : '/active-sign/notes-detail/' + row.id + '/' + this.id
      this.$router.push(link)
    }
  },
  created () {
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-active-sign-notes{
  :global{
    table{
      .el-button{
        margin-left: 0;
        margin-right: 10px
      }
    }
  }
}
</style>
